<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="product"
      hide-default-footer
      class="elevation-0"
      disable-pagination
      disable-sort
    >
      <template v-slot:item.prodName="{item}">
        <span
          class="subtitle-2 font-weight-medium"
        >{{item.description}} {{item.variety ? `-${item.variety}` :''}} {{item.size ? `-${item.size}`:''}}</span>
      </template>
      <template v-slot:item.prodQuantity="{item}">
        <span class="subtitle-2 font-weight-medium">{{parseFloat(item.quantity).toFixed(2)}}</span>
      </template>
      <template v-slot:item.prodTotal="{item}">
        <span class="subtitle-2 font-weight-medium">£ {{parseFloat(item.total).toFixed(2)}}</span>
      </template>
      <template v-slot:item.prodAverage="{item}">
        <span class="subtitle-2 font-weight-medium">£ {{parseFloat(item.average).toFixed(2)}}</span>
      </template>
      <template v-slot:no-data>
        <span class="subtitle-2 font-weight-medium">No Data Found</span>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  name: "ProductStats",
  props: ["product"],
  data: () => {
    return {
      headers: [
        { text: "Product", value: "prodName", sortable: false },
        { text: "Quantity", value: "prodQuantity", sortable: false },
        { text: "Quantity Type", value: "quantity_type", sortable: false },
        { text: "Total", value: "prodTotal" },
        { text: "Average", value: "prodAverage" }
      ]
    };
  },
  computed: {},
  methods: {}
};
</script>